import { useEffect, useState } from 'react';
import CloseButton from '../CloseButton';
import Input from '../Input';
import './update-class.css';
import { get, put } from '../../services/api';
import { useUI } from '../../UIContext';
import { handleErr } from '../../utils/functions';
import { isValidVideoEmbed } from '../../utils/functions';
import TextArea from '../TextArea';

function UpdateClass({ classId, onSuccess = () => {}, onClose = () => {} }) {
    const { setLoading, setMessage } = useUI();
    const [classLoaded, setClassLoaded] = useState({});
    const [submitAttempt, setSubmitAttempt] = useState(false);
    const [hasSavedProcess, setHasSavedProcess] = useState(false);

    useEffect(() => {
        async function getClass() {
            setLoading(true);

            await get(`/module/class/${classId}`, true, setMessage,
                (response) => {
                    setClassLoaded(response.data);
                },
                (err) => {
                    handleErr(setMessage, `Erro ao carregar a aula: ${err}`);
                },
                () => {
                    setLoading(false);
                }
            )
        }

        getClass();
    }, [setLoading, setMessage, setClassLoaded, classId]);

    function isNameValid() {
        return !!classLoaded.name && classLoaded.name.length >= 3;
    }

    function isDescriptionValid() {
        return !!classLoaded.description && classLoaded.description.length >= 5;
    }

    function isVideoUrlValid() {
        return !!(classLoaded.video && classLoaded.video.url) && isValidVideoEmbed(classLoaded.video?.url);
    }

    async function onClickSave(e) {
        e.preventDefault();

        function isSaveValid() {
            setSubmitAttempt(true);

            return isNameValid() && isDescriptionValid() && isVideoUrlValid();
        }

        e.preventDefault();

        if (!isSaveValid())
            return;

        setLoading(true);

        const data = {
            name: classLoaded.name,
            description: classLoaded.description,
            videoUrl: classLoaded.video?.url || ''
        };

        await put(`module/class/${classId}`, data, true, setMessage,
            () => {
                setHasSavedProcess(true);
                setMessage({ type: 'success', text: 'A aula foi alterada.' });
                onSuccess();
            },
            (err) => {
                handleErr(setMessage, `Não foi possível salvar a aula: ${err}`);
            },
            () => {
                setLoading(false);
            }
        );
    }

    return (
        <form className='container-update-class'>
            <header className='container-header'>
                <h1>Editar Aula</h1>

                <CloseButton onClick={(e) => {
                    onClose();
                }} shouldConfirm={!hasSavedProcess} />
            </header>

            <Input
                className='commom-input glass-effect-15'
                type='text'
                value={classLoaded.name}
                onChange={(e) => setClassLoaded({
                    ...classLoaded,
                    name: e.target.value
                })}
                onValidate={isNameValid}
                placeholder='Nome'
                shouldValidate={submitAttempt}
                maxLength={100}
                warningMsg='O nome deve conter ao menos 3 caracteres.'
            />

            <TextArea
                cols='4'
                rows='4'
                className='commom-input glass-effect-15'
                value={classLoaded.description}
                onChange={(e) => setClassLoaded({
                    ...classLoaded,
                    description: e.target.value
                })}
                onValidate={isDescriptionValid}
                placeholder='Descrição'
                shouldValidate={submitAttempt}
                maxLength={1000}
                warningMsg='A descrição deve conter ao menos 5 caracteres.'
            />

            <div className='container-video-preview'>
                {!isVideoUrlValid() && (
                    <div className='no-video-url'>
                        <p>Insira a URL do seu vídeo.</p>
                    </div>
                )}

                {isVideoUrlValid() && (
                    <iframe
                        src={classLoaded.video?.url}
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        title={classLoaded.name}>
                    </iframe>
                )}
            </div>

            <Input
                className='commom-input glass-effect-15'
                type='text'
                value={classLoaded.video?.url || ''}
                onChange={(e) => setClassLoaded({
                    ...classLoaded,
                    video: {
                        ...(classLoaded.video || {}),
                        url: e.target.value
                    }
                })}
                onValidate={isVideoUrlValid}
                placeholder='URL do vídeo'
                shouldValidate={submitAttempt}
                maxLength={100}
                warningMsg='A URL do vídeo precisa ser informada com um vídeo do player Vimeo.'
            />

            <div className='container-save-form'>
                <button className='gray-button cancel-update-class' onClick={() => onClose()}>Cancelar</button>

                <button
                    type='submit'
                    onClick={onClickSave}
                    className='blue-button zoom-effect'>
                    Salvar
                </button>
            </div>
        </form>
    );
}

export default UpdateClass;